import { render, staticRenderFns } from "./BookingBoardTemplateDialog.vue?vue&type=template&id=7769e430"
import script from "./BookingBoardTemplateDialog.vue?vue&type=script&lang=js"
export * from "./BookingBoardTemplateDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports